export default __webpack_public_path__ + "media/images/images/gallery/40-b47f812cfce35a6bc5997ac2c760756c.png";